import React from 'react'
import { components, DropdownIndicatorProps } from 'react-select'

import { GroupedSelectOption } from '@/components/form/MultiSelectInput'
import { SelectOption } from '@/types/misc'

const ReactSelectDropdownIndicator = <IsMulti extends boolean = boolean>(
  props: DropdownIndicatorProps<SelectOption, IsMulti, GroupedSelectOption>,
) => {
  const menuIsOpen = props.selectProps.menuIsOpen

  function renderIndicator() {
    if (!menuIsOpen) {
      return <components.DropdownIndicator {...props} />
    }

    return (
      <components.DropdownIndicator {...props}>
        <span className="text-primary cursor-pointer px-1">Done</span>
      </components.DropdownIndicator>
    )
  }

  return <>{renderIndicator()}</>
}

export default ReactSelectDropdownIndicator
